import { Empty } from "antd";
import { Link } from "react-router-dom";

const Orders = ({ items = [] }) => {
  console.log("items", items);
  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap vertical-top">
                Order ID
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Product Name
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Order Delivery Date
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                SubtotalAmount
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Vat
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Distance KM
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Discount
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Delivery Fee
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Platform Fee
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Deductions
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Payout Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {items?.length ? (
              items?.map((item, index) => (
                <tr className="bg-white border-b text-gray-700">
                  <Link className="cursor-pointer text-#176b53" to={`/order-management/?order_number=${item?.orderNumber}`}>
                    <td className="px-3 py-4 vertical-top font-semibold cursor-pointer text-#176b53">{item?.orderNumber}</td>
                  </Link>
                  <td className="px-3 py-4 vertical-top">{item?.productName}</td>
                  <td className="px-3 py-4 vertical-top">{item?.orderDeliveryDate}</td>
                  <td className="px-3 py-4 vertical-top">{Number(item?.subTotal) > 0 ? Number(item?.subTotal).toFixed(2) : 0}</td>
                  <td className="px-3 py-4 vertical-top">SAR {Number(item?.vat) > 0 ? Number(item?.vat).toFixed(2) : 0}</td>
                  <td className="px-3 py-4 vertical-top">{ Number(item?.distanceKM).toFixed(2) }</td>

                  <td className="px-3 py-4 vertical-top">SAR {Number(item?.discount) > 0 ? Number(item?.discount).toFixed(2) : 0}</td>
                  <td className="px-3 py-4 vertical-top">SAR {Number(item?.deliveryFee) > 0 ? Number(item?.deliveryFee).toFixed(2) : 0}</td>
                  <td className="px-3 py-4 vertical-top">
                    SAR {Number(item?.plateformFee) > 0 ? Number(item?.plateformFee).toFixed(2) : 0}
                  </td>
                  <td className="px-3 py-4 vertical-top">SAR {Number(item?.deductions) > 0 ? Number(item?.deductions).toFixed(2) : 0}</td>
                  <td className="px-3 py-4 vertical-top">
                    SAR { Number(item?.payoutAmount).toFixed(2) }
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center mt-3">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Orders;
